import React, { useEffect, useState } from "react";
import "./styles.scss";
import { tt } from "../../utils/i18n/i18n";

declare const $: any;

interface Props {
  id?: string;
  children: JSX.Element | React.ReactNode;
  placeholder?: string;
  isDouble?: boolean;
  className?: string;
}

export default function KC_CustomSelect(props: Props) {
  const [isSelectOpen, setIsSelectOpen] = useState(false);

  useEffect(() => {
    const dropdownButton = document.getElementById(props.id!);
    if (dropdownButton) {
      // Listen to Bootstrap dropdown events);
      $(dropdownButton)
        .parent()
        .on("show.bs.dropdown", () => {
          setIsSelectOpen(true);
        });
      $(dropdownButton)
        .parent()
        .on("hide.bs.dropdown", () => {
          setIsSelectOpen(false);
        });
    }
    return () => {
      if (dropdownButton) {
        $(dropdownButton).parent().off("show.bs.dropdown hide.bs.dropdown");
      }
    };
  }, [props.id]);

  return (
    <>
      {isSelectOpen && (
        <div
          className="select-overlay d-block d-sm-none"
          onClick={() => setIsSelectOpen(false)}
        />
      )}
      <div
        className={`btn-group ${props.className || "dropup"} kc-input-wrapper kc-custom-select`}
        style={{
          height: 40
        }}
      >
        <button
          className="h-100 btn btn-light dropdown-toggle w-100 text-left border d-flex justify-content-between align-items-center"
          type="button"
          id={props.id}
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          style={{
            backgroundColor: "#fff",
            fontSize: "1rem",
            fontWeight: "normal"
          }}
        >
          <span>{props.placeholder || tt("selectAtLeastOneOption")}</span>
        </button>

        <div
          className={`dropdown-menu ${props.isDouble ? "kc-dropdown-menu-double" : ""}`}
          aria-labelledby={props.id}
        >
          {props.children}
        </div>
      </div>
    </>
  );
}

interface KC_CustomSelectChildProps {
  children: JSX.Element | React.ReactNode | string;
  isDouble?: boolean;
  onClick?: (e: any) => void;
}

export function KC_CustomSelectChild(props: KC_CustomSelectChildProps) {
  return (
    <div
      className={`dropdown-item cursor-pointer ${props.isDouble ? "pl-0" : ""}`}
      onClick={props.onClick}
    >
      {props.children}
    </div>
  );
}
